let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4k2DV")).then(() => parcelRequire('8GJZM'));